import { CLASSES } from "@/scripts/helpers/constants";

const suggestionList = $(".suggestions-list");
const searchControls = $(".js-search-controls");
const cleanSearch = $(".js-search-clean");
const searchWrapper = $(".js-search-wrapper");
const searchHeader = $(".search input, .search-header input");
const searchIconHeader = $(".js-search-icon-header");
const donateBanner = $(".donate-ua-banner");

if (document.cookie.indexOf("COOKIES_DONATE") === -1 && !$(".js-search-page").length) {
  $(searchIconHeader).on("click", function(event) {
    donateBanner.toggleClass("donate-ua-banner--higher");
  });
} else if (document.cookie.indexOf("COOKIES_DONATE") === -1 && $(".js-search-page").length) {
  $(".page-section--search-result").addClass(CLASSES.IS_ACTIVE)
}

$(cleanSearch).on("click", function(event) {
  $(searchWrapper).removeClass(CLASSES.IS_VISIBLE);
  $(searchHeader).val("");
  event.preventDefault();
  donateBanner.removeClass("donate-ua-banner--higher");
});

$(searchIconHeader).on("click", function(event) {
  event.preventDefault();
  $(searchWrapper).toggleClass(CLASSES.IS_VISIBLE);
  $(searchHeader).focus();
});

$(searchHeader).each(function() {
  $(this).on("keyup change", function(event) {
    suggestionList.removeClass(CLASSES.IS_VISIBLE);

    if (event.target.value === "") {
      suggestionList.addClass(CLASSES.IS_VISIBLE);
    } else if (event.target.value.length > 2 && event.keyCode !== 13) {
      $(searchControls).addClass(CLASSES.IS_VISIBLE);
    } else {
      $(searchControls).removeClass(CLASSES.IS_VISIBLE);
    }
  });

  $(this).focusin(function(event) {
    $(".mobile-menu").addClass("suggestion-active");

    if (event.target.value === "") {
      suggestionList.addClass(CLASSES.IS_VISIBLE);
    } else if (event.target.value.length > 2) {
      $(searchControls).addClass(CLASSES.IS_VISIBLE);
    } else {
      $(searchControls).removeClass(CLASSES.IS_VISIBLE);
    }
  });

  $(this).focusout(function(e) {
    $(searchControls).removeClass(CLASSES.IS_VISIBLE);
    $(".mobile-menu").removeClass("suggestion-active");
  });
});

$(document).click(function(e) {
  if (e.target.nodeName !== "INPUT") {
    suggestionList.removeClass(CLASSES.IS_VISIBLE);
  }
});
